//AllModels

import {default  as renderXSpan } from "./Models/XSpan/render";

const  listModels = [
    {name:"XSpan",type:"XSpan"},
];

export function getModels(type) {
    let i;
    let l=listModels.length;
    let res=[];
    for (i = 0; i < l; i++) {
        if(listModels[i].type===type){
            res.push(listModels[i]);
        }
    }
    return res;
}

export default function getModel(name) {
    let i;
    let l=listModels.length;
    let res=null;
    for (i = 0; i < l; i++) {
        if(listModels[i].type===name){
            res=listModels[i];
            break;
        }
    }
    return res;
}

export function renderModel(name,value,props= {}) {
    let res=null;
    let m=getModel(name);
    if(m!==null) {
        switch (m.type) {
            case   "XSpan":
                res=renderXSpan(value,props);
                break;
            default:  break;
        }
    }
     return res;
}
